import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faCompress, faFileArchive, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

const FileSizeHelper = ({ fileType = 'general' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const getFileTypeInfo = () => {
    switch (fileType) {
      case 'malware_sample':
        return {
          maxSize: '50MB',
          allowedTypes: 'ZIP files only',
          showTips: true,
          tips: [
            'Use 7-Zip, WinRAR, or built-in compression tools',
            'Password-protect sensitive malware samples',
            'Include multiple samples in one ZIP file if needed',
            'Use maximum compression settings'
          ]
        };
      default:
        return {
          maxSize: '10MB',
          allowedTypes: 'PDF, DOC, DOCX, TXT, JPG, PNG, GIF',
          showTips: false,
          tips: []
        };
    }
  };

  const { maxSize, allowedTypes, showTips, tips } = getFileTypeInfo();

  return (
    <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <div 
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center space-x-2">
          <FontAwesomeIcon icon={faInfoCircle} className="text-blue-500" />
          <span className="text-sm font-medium text-blue-800">File Size Guidelines</span>
        </div>
        <FontAwesomeIcon 
          icon={isExpanded ? faChevronUp : faChevronDown} 
          className="text-blue-500 text-sm"
        />
      </div>
      
      {isExpanded && (
        <div className="mt-3 space-y-2">
          <div className="text-sm text-blue-700">
            <div><strong>Maximum size:</strong> {maxSize} per file</div>
            <div><strong>Allowed types:</strong> {allowedTypes}</div>
          </div>
          
          {showTips && (
            <div className="border-t border-blue-200 pt-2">
              <div className="flex items-center space-x-2 mb-2">
                <FontAwesomeIcon icon={faCompress} className="text-blue-500" />
                <span className="text-sm font-medium text-blue-800">Compression Tips:</span>
              </div>
              <ul className="text-sm text-blue-700 space-y-1">
                {tips.map((tip, index) => (
                  <li key={index} className="flex items-start space-x-2">
                    <span className="text-blue-400 mt-1">•</span>
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          {fileType === 'malware_sample' && (
            <div className="border-t border-blue-200 pt-2">
              <div className="flex items-center space-x-2 mb-1">
                <FontAwesomeIcon icon={faFileArchive} className="text-blue-500" />
                <span className="text-sm font-medium text-blue-800">Security Note:</span>
              </div>
              <p className="text-sm text-blue-700">
                Only ZIP files are accepted for malware samples for security reasons. 
                Ensure samples are properly contained and consider password protection.
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FileSizeHelper;